import _ from 'lodash'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPropsStore, Props, SdkHandlersProvider } from '@wix/thunderbolt-symbols'
import { serializeEvent } from './utils'
import { NCMSdkHandlers } from '../types'

export default withDependencies(
	[Props],
	(propsStore: IPropsStore): SdkHandlersProvider<NCMSdkHandlers> => {
		const registeredCbs: {
			[__cbId: string]: (...args: Array<any>) => void
		} = {}

		let cbIndex = 0
		let cache = {}

		return {
			getSdkHandlers: () => ({
				ncm: {
					triggerRegisteredCb: (__cbId: string, dataProps, functionNames, invokeFunction) => {
						if (registeredCbs[__cbId]) {
							functionNames.forEach((functionName) =>
								_.set(dataProps, functionName, (...args: any) => {
									if (process.env.browser || process.env.NODE_ENV === 'test') {
										const serializedEvent = serializeEvent(args)
										invokeFunction(functionName, serializedEvent)
									}
									return
								})
							)
							registeredCbs[__cbId](dataProps)
						}
					},
					setProps: (compId, dataProps, functionNames, invokeFunction) => {
						functionNames.forEach((functionName) =>
							_.set(dataProps, functionName, (...args: any) => {
								if (process.env.browser || process.env.NODE_ENV === 'test') {
									if (typeof args[0] === 'function') {
										const cb = args[0]
										const __cbId = `cb${cbIndex++}`
										registeredCbs[__cbId] = cb
										invokeFunction(functionName, { __cbId })
									} else {
										const serializedEvent = serializeEvent(args)
										invokeFunction(functionName, serializedEvent)
									}
								} else {
									throw new Error(
										`NCM component ${compId} attempted to invoke ${functionName} during SSR - function props can only be invoked on user interaction or mount handlers of the component`
									)
								}
								return
							})
						)

						cache = _.merge(cache, dataProps)
						propsStore.update({ [compId]: cache })
					},
				},
			}),
		}
	}
)
